import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

export interface MyRouterContext {
	queryClient: QueryClient;
	auth: {
		isAuthenticated: () => boolean;
		getAuthToken: () => Promise<string | null>;
		ensureValidToken: () => Promise<boolean>;
	};
}
export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => <Outlet />,
});
